module.exports = __webpack_public_path__ + "img/20190318_103700 (1).cda047a0.jpg";